import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import { RunService } from '../services/service';
import { Questions, RubricBins, QuestionCategory } from '../models/questions';
import { ModelSettings } from '../models/modelsettings';

type AOA = any[][];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  showDataView: boolean;
  files: Array<File> = [];
  holistic = false;
  notNewPrompt = false;
  data: AOA = [];
  runIndividual = false;
  isProcess = true;
  columns: any[];
  wopts: XLSX.WritingOptions = {
    bookType: 'xlsx',
    type: 'array'
  };
  title = 'AACR Confirmatory Analysis';
  modelSettings: ModelSettings;
  questions: Array<Questions> = [];
  filteredQuestions: Array<Questions> = [];
  isNew: boolean;
  notNew: boolean;
  newRubricPrompt: boolean;
  question: Questions | null = null;
  rubrics: Array<RubricBins>;
  existingQuestion = false;
  isCategory = false;
  questionCat: QuestionCategory;
  questionCats: Array<QuestionCategory>;
  loading_question: boolean = false;
  relation_help: boolean = false;
  selectedVersion = null;
  questionSelected: boolean = false;
  loadingRevision = false;
  questionFilterText: string = '';
  errors: Array<string> = [];
  showCategory: boolean = false;

  constructor(private service: RunService) { }

  ngOnInit() {
    this.questionCats = new Array<QuestionCategory>();
    this.questionCat = new QuestionCategory();
    this.rubrics = new Array<RubricBins>();
    this.isNew = false;
    this.notNew = true;
    this.question = null;
    this.showDataView = true;
    this.newRubricPrompt = true;
    this.getQuestions();
    this.data = null;
    this.runIndividual = false;
    this.modelSettings = new ModelSettings();
    this.modelSettings.Analytic = true;
    this.modelSettings.UseDefaultStopWords = true;
    this.modelSettings.KeepNumbers = true;
    this.modelSettings.NgramLength = 1;
    this.modelSettings.EnsemblingMethod = 'Majority';
  }

  handleType(type: string) {
    if (!this.question) {
      return;
    }
    this.modelSettings.Analytic = false;
    this.modelSettings.Holistic = false;
    if (type === 'holistic') {
      this.modelSettings.Holistic = true;
      this.question.rubric_type = 'Typed';
      this.showCategory = false;
    }
    if (type === 'analytic') {
      this.modelSettings.Analytic = true;
      this.question.rubric_type = 'Binary';
      this.showCategory = true;
    }
  }

  addQuestionCat() {
    this.questionCats.push(this.questionCat);
    this.questionCat = new QuestionCategory();
  }

  selectModel(model: string) {
    this.modelSettings.Binary = false;
    this.modelSettings.Svm = false;
    this.modelSettings.Lda = false;
    this.modelSettings.Rf = false;
    this.modelSettings.Logit = false;
    this.modelSettings.Maxent = false;
    this.modelSettings.Bagging = false;
    this.modelSettings.Glment = false;
    if (model === 'binary') {
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.Binary = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'binary';
    }
    if (model === 'svm') {
      this.modelSettings.Svm = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'svm';
    }
    if (model === 'lda') {
      this.modelSettings.Lda = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'lda';
    }
    if (model === 'rf') {
      this.modelSettings.Rf = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'rf';
    }
    if (model === 'logit') {
      this.modelSettings.Logit = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'logit';
    }
    if (model === 'maxent') {
      this.modelSettings.Maxent = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.Binary = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'maxemt';
    }
    if (model === 'bag') {
      this.modelSettings.Bagging = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'bagging';
    }
    if (model === 'glment') {
      this.modelSettings.Glment = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'glment';
    }
  }

  onFileChange(evt: any) {
    const _files = evt.target.files;
    this.files = [];
    const len = _files.length;

    for (let i = 0; i < len; ++i) {
      this.files.push(_files[i]);
    }
    const target: DataTransfer = evt.target as DataTransfer;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as AOA;
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onFileClick(evt: any) {
    this.data = null;
  }

  stopWordsClick(button: string) {
    if (button === 'default') {
      this.modelSettings.UseDefaultStopWords = true;
      this.modelSettings.UseCustomStopWords = false;
    }
    if (button === 'no') {
      this.modelSettings.UseDefaultStopWords = false;
      this.modelSettings.UseCustomStopWords = false;
    }
    if (button === 'custom') {
      this.modelSettings.UseDefaultStopWords = null;
      this.modelSettings.UseCustomStopWords = true;
    }
  }

  setTab(tabName: string) {
    const processElem: HTMLElement = document.getElementById('process');
    const categoryElem: HTMLElement = document.getElementById('category');

    if (categoryElem && processElem) {
      categoryElem.className = '';
      processElem.className = '';
    }
    this.isProcess = false;
    this.isCategory = false;

    if (tabName === 'process') {
      this.isProcess = true;
    }
    if (tabName === 'category') {
      this.isCategory = true;
    }

    const tabElement: HTMLElement = document.getElementById(tabName);
    if (tabElement) {
      tabElement.className = 'is-active';
    }
  }

  radioBtnClick(value: string) {
    if (value === 'new') {
      this.isNew = true;
      this.existingQuestion = false;
      this.notNew = false;
      this.question = new Questions();
      this.questionFilter('');
    } else if (value === 'no') {
      this.notNew = true;
      this.isNew = false;
    } else if (value === 'newP') {
      this.notNewPrompt = false;
    } else if (value === 'noP') {
      this.notNewPrompt = true;
    }
  }

  setView(view: string) {
    if (view === 'data') {
      this.showDataView = true;
    } else {
      this.showDataView = false;
    }
  }

  getQuestions(): Promise<any> {
    const promise = this.service.getQuestions().toPromise();
    this.loading_question = true;

    promise
      .then(r => {
        const q = new Questions();
        q.question_text = 'Choose a question';
        q.question_name = '';

        const j = r
          .sort((a, b) => (a.question_name < b.question_name ? -1 : 1))
          .map(n => {
            n.question_text = n.question_name;
            return n;
          });
        this.questions = [q].concat(j);

        this.filteredQuestions = this.questions;
        this.loading_question = false;
      })
      .catch(e => {
        console.log(e);
        this.loading_question = false;
      });
    return promise;
  }

  getQuestionVersionData(questionVersion: any) {
    this.errors = [];
    this.loadingRevision = true;
    this.service
      .getQuestionDataById(this.question.id, questionVersion)
      .toPromise()
      .then(
        r => {
          this.question = r;
          this.question.question_archived = r.archived;
          if (this.question.rubric_type === 'analytic') {
            this.modelSettings.Analytic = true;
            this.showCategory = true;
          }
          this.existingQuestion = true;
          this.loadingRevision = false;
          this.getQuestionCatsByIdAndVersion(this.question.id, questionVersion);
        },
        () => {
          this.loadingRevision = false;
        }
      );
  }

  questionFilter(filter: any) {
    this.filteredQuestions = this.questions.filter(r =>
      r.question_name.toLowerCase().includes(filter.toLowerCase())
    );
    this.getQuestionDataById(this.filteredQuestions[0].id);
  }

  getQuestionDataById(questionId: number) {
    this.loading_question = true;
    this.questionSelected = true;
    if (questionId === null) {
      this.loading_question = false;
      return;
    }
    this.service
      .getQuestionDataById(questionId)
      .toPromise()
      .then(r => {
        this.question = r;
        this.question.question_archived = r.archived;

        this.modelSettings.Analytic =
          this.question.rubric_type != null &&
          this.question.rubric_type.toLowerCase() === 'binary';
        this.modelSettings.Holistic = !this.modelSettings.Analytic;

        this.showCategory = this.modelSettings.Analytic;

        this.existingQuestion = true;
        this.loading_question = false;
        this.getQuestionCats(this.question.id);
        this.selectedVersion = +this.question.question_version;
      },
      () => {
        this.loading_question = false;
      });
  }

  addRubricButtonText(): string {
    return this.modelSettings.Analytic ? 'Add Bin' : 'Add Code';
  }

  getQuestionCats(questionId: number) {
    this.questionCats = new Array<QuestionCategory>();
    this.service
      .getQuestionCats(questionId)
      .toPromise()
      .then(r => {
        this.questionCats = r;
        this.loading_question = false;
      });
  }

  getQuestionCatsByIdAndVersion(questionId: number, version: string) {
    this.loading_question = false;
    this.questionCats = new Array<QuestionCategory>();
    this.service
      .getQuestionCatsByIdAndVersion(questionId, version)
      .toPromise()
      .then(r => {
        this.questionCats = r;
        this.loading_question = false;
      });
  }

  hasError(key: string): boolean {
    return this.errors.includes(key);
  }

  saveQuestionInfo() {
    if (!this.question) {
      window.alert('You indicated this is an existing question and did not select one');
      return;
    }

    if (this.notNew === true) {
      if (this.question.id === 0) {
        window.alert('You indicated this is an existing question and did not select one');
        return;
      }

      if (this.question.question_archived === false) {
        // this.question.question_version = '' + (parseInt(this.question.question_version, 10) + 1);
      }
    }

    this.question.question_name = this.question.question_name.trim();
    this.question.question_text = this.question.question_text.trim();

    if (this.question.question_name.length === 0) {
      this.errors.push('QuestionNameRequired');
    }

    if (this.question.question_text.length === 0) {
      this.errors.push('QuestionTextRequired');
    }

    if (this.errors.length > 0) {
      alert('There were errors, details shown at the field(s)');
      return;
    }

    this.service
      .saveQuestion(this.question)
      .toPromise()
      .then(r => {
        const questionId = r;

        const savePromises = [this.saveBins(questionId), this.saveCategories(questionId)];

        Promise.all(savePromises).then(
          () => {
            alert('Question saved');

            this.getQuestions().then(() => {
              this.questionFilterText = this.question.question_name;
              this.questionFilter(this.question.question_name);
              this.getQuestionDataById(this.question.id);
              this.question = new Questions();
              this.questionCats = [];
              this.isNew = false;
              this.notNew = true;
              this.modelSettings.Analytic = true;
              this.modelSettings.Holistic = false;
              this.showCategory = true;
            });
          },
          error => {
            console.error(error);
          }
        );
      })
      .catch(e => {
        console.log(e);
        window.alert('There wa a problem saving the question');
      });
  }

  private saveBins(questionId: number): Promise<any> {
    const saveBinPromise = new Promise<any>((resolve, reject) => {
      const binPromises = [];
      if (this.question.question_archived === false) {
        const levels = this.question.rubricLevels.filter(bin => bin.rubric_level != null);
        levels.forEach(bin => {
          bin.question_id = questionId;
        });
        binPromises.push(this.service.saveBins(levels).toPromise());
      }
      Promise.all(binPromises).then(resolve, reject);
    });

    return saveBinPromise;
  }

  private saveCategories(questionId: number): Promise<any> {
    const saveCategoryPromise = new Promise<any>((resolve, reject) => {
      const categoryPromises = [];
      this.questionCats.forEach(cat => {
        cat.question_id = questionId;
        categoryPromises.push(this.service.saveQuestionCategory(cat).toPromise());
      });

      Promise.all(categoryPromises).then(resolve, reject);
    });

    return saveCategoryPromise;
  }

  addRubric() {
    if (!this.question) {
      return;
    }
    this.question.rubricLevels.push(new RubricBins(this.question.rubricLevels.length + 1));
  }

  showRelationHelp(id: string) {
    this.relation_help = !this.relation_help;
  }

  cancelBin(index: number) {
    this.question.rubricLevels = this.question.rubricLevels.filter((r, i) => i !== index);
  }

  deleteBin(binId: number) {
    if (!confirm('Are you sure you want to delete this bin?')) {
      return;
    }

    const promise = this.service.deleteBin(binId).toPromise();
    const error = (e: any) => {
      alert('There was a problem deleting this bin.');
      console.error(e);
    };
    promise
      .then(() => {
        this.question.rubricLevels = this.question.rubricLevels.filter(r => r.id !== binId);
      }, error)
      .catch(error);
    return promise;
  }
}

